import InvestorMailboxContent from './investor-mailbox-content';

export default InvestorMailboxContent;
